import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core'
import { UnfilteredTag } from 'elements-sdk/src'

@Component({
  selector: 'media-tag',
  templateUrl: './mediaTag.component.pug',
  styleUrls: ['./mediaTag.component.scss'],
  host: {
    '[style.border-color]': 'tag.color',
    '[style.color]': 'tag.color',
    '[title]': 'tag.name',
    'data-test-qa': 'tagBadge',
  },
})
export class MediaTagComponent {
  @Input() tag: UnfilteredTag
  @Input() removeButton = false
  @Output() remove = new EventEmitter()

  constructor (private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit () {
    for (const cls of [
      'badge',
      'badge-pill',
      'badge-outline-secondary',
      'no-wrap',
    ]) {
      this.elementRef.nativeElement.classList.toggle(cls, true)
    }
  }
}
